export function createFixedLoop(stepFn: () => void, dt = 1 / 60, maxSteps = 5): { update(elapsedMs: number): number; alpha(): number; reset(): void } {
  let acc = 0;
  return {
    update(elapsedMs) {
      acc = Math.min(acc + elapsedMs / 1000, dt * maxSteps);
      let steps = 0;
      while (acc >= dt - 1e-9 && steps < maxSteps) { stepFn(); acc -= dt; steps++; }
      if (steps === maxSteps) acc = 0;
      return steps;
    },
    alpha: () => Math.min(1, Math.max(0, acc / dt)),
    /** Remet l'accumulateur à zéro (reprise après une pause : pas de rattrapage). */
    reset() { acc = 0; },
  };
}
